import { IProfileApi } from './Interface/IProfileApi';
import { ApiService } from '@/services/ApiService';
import { CompleteProfileDto, CreateProfileDto, CreateProfileResponseDto, ProfileDto, UpdateProfileDto } from '@/types/webapi';

export default class ProfileApi extends ApiService implements IProfileApi {
    async getProfile(): Promise<ProfileDto> {
        const result = await this.httpGet<ProfileDto>('/api/fort/profiles/me');
        return result!;
    }

    async registerProfile(createProfile: CreateProfileDto): Promise<CreateProfileResponseDto> {
        return await this.httpPost<CreateProfileResponseDto>('/api/v1.0/profile', createProfile);
    }

    async updateProfile(updateProfile: UpdateProfileDto): Promise<ProfileDto> {
        return this.httpPut('/api/v1.0/profile', updateProfile);
    }

    async completeProfile(completeProfile: CompleteProfileDto): Promise<CreateProfileResponseDto> {
        return await this.httpPost<CreateProfileResponseDto>('/api/v1.0/profile/complete', completeProfile);
    }

    async updateEmail(email: { email: string }): Promise<void> {
        return this.httpPost<void>('/api/v1.0/profile/email', email);
    }

    async updatePassword(password: { password: string; passwordConfirm: string; existingPassword: string }): Promise<void> {
        if (password.password !== password.passwordConfirm) {
            throw new Error('Passwords do not match');
        }

        return this.httpPut<void>('/api/fort/profiles/me/user/credentials', {
            password: password.password,
            existingPassword: password.existingPassword
        });
    }

    async updateTwoFactor(twoFactorEnabled: boolean): Promise<ProfileDto> {
        return this.httpPut('/api/fort/profiles/me/user', { twoFactorEnabled: twoFactorEnabled });
    }

    async deleteProfile(): Promise<void> {
        return this.httpDelete<void>('/api/fort/profiles/me');
    }
}
